/**
 * 页头或页脚 fixed 布局
 *
 * 用例：
 * ```js
 * <FixedLayout>
 *  <FixedLayoutHeader height='1rem'>
 *    <div>fixed header content</div>
 *  </FixedLayoutHeader>
 *
 *  <FixedLayoutBody headerHeight='1rem' footerHeight='0.9rem'>
 *    <div>main content  scroll-y auto</div>
 *  </FixedLayoutBody>
 *
 *  <FixedLayoutFooter height='0.9rem'>
 *    <div>fixed footer content</div>
 *  </FixedLayoutFooter>
 * </FixedLayout>
 * ```
 */

import './index.css';


// fuck android  poistion: fixed; 实现
import FixedLayout, {
  FixedLayoutHeader,
  FixedLayoutBody,
  FixedLayoutFooter
} from './fixed';

// position: absolute; 实现
import AbsoluteLayout, {
  AbsoluteLayoutHeader,
  AbsoluteLayoutBody,
  AbsoluteLayoutFooter
} from './absolute';

import FlexLayout, {
  FlexLayoutHeader,
  FlexLayoutBody,
  FlexLayoutFooter
} from './flex';

export {
  FixedLayout,
  FixedLayoutHeader,
  FixedLayoutBody,
  FixedLayoutFooter,

  AbsoluteLayout,
  AbsoluteLayoutHeader,
  AbsoluteLayoutBody,
  AbsoluteLayoutFooter,

  FlexLayout,
  FlexLayoutHeader,
  FlexLayoutBody,
  FlexLayoutFooter
};


// // 为了兼容
// export default AbsoluteLayout;
// export {
//   AbsoluteLayoutHeader as FixedLayoutHeader,
//   AbsoluteLayoutBody as FixedLayoutBody,
//   AbsoluteLayoutFooter as FixedLayoutFooter
// };

// export {
//   FixedLayout as FixedLayout2,
//   FixedLayoutHeader as FixedLayoutHeader2,
//   FixedLayoutBody as FixedLayoutBody2,
//   FixedLayoutFooter as FixedLayoutFooter2
// };



// WEBPACK FOOTER //
// ./src/components/FixedLayout/index.js